import { render, staticRenderFns } from "./Signatures.vue?vue&type=template&id=34d0006a&scoped=true"
import script from "./Signatures.vue?vue&type=script&lang=js"
export * from "./Signatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d0006a",
  null
  
)

export default component.exports